
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#C8E9FF"}}),_c('path',{attrs:{"d":"M18.4 22.4l-5.987-6 5.987-6","stroke":"#0073BE","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    